export default {"src":"/_next/static/media/cart-shopping-solid.1332b74c.svg","height":512,"width":576};